import { render, staticRenderFns } from "./ReportDataDetails.vue?vue&type=template&id=70e6bb24&scoped=true&"
import script from "./ReportDataDetails.vue?vue&type=script&lang=js&"
export * from "./ReportDataDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReportDataDetails.vue?vue&type=style&index=0&id=70e6bb24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6bb24",
  null
  
)

export default component.exports